<div>
  <div class="d-flex justify-content-center">
    <div class="col-lg-6 col-md-8 col-sm-10">
      <h1 jhiTranslate="login.title" data-cy="loginTitle">Anmeldung</h1>
      @if (authenticationError) {
        <div class="alert alert-danger" jhiTranslate="login.messages.error.messageNewPage" data-cy="loginError">
          <strong>Anmeldung fehlgeschlagen!</strong> Überprüfe  bitte deine Angaben und versuche es erneut.
        </div>
        <div class="alert alert-danger" jhiTranslate="login.messages.error.authentication" data-cy="loginError">
          <strong>Anmeldung fehlgeschlagen!</strong> Überprüfen Sie bitte Ihre Angaben und versuchen Sie es erneut.
        </div>
      }
      <form class="form" role="form" (ngSubmit)="login()" [formGroup]="loginForm">
        <div class="mb-3">
          <label class="username-label" for="username" jhiTranslate="global.form.username.label">Benutzername</label>
          <input
            type="text"
            class="form-control"
            name="username"
            id="username"
            placeholder="{{ 'global.form.username.placeholder' | translate }}"
            formControlName="username"
            #username
            data-cy="username"
          />
        </div>

        <div class="mb-3">
          <label for="password" jhiTranslate="login.form.password">Passwort</label>
          <input
            type="password"
            class="form-control"
            name="password"
            id="password"
            placeholder="{{ 'login.form.password.placeholder' | translate }}"
            formControlName="password"
            data-cy="password"
          />
        </div>

        <button type="submit" class="btn btn-primary" jhiTranslate="login.form.button" data-cy="submit">Anmelden</button>
      </form>
      <div class="mt-3 alert alert-warning">
        <a class="alert-link" routerLink="/account/reset/request" jhiTranslate="login.password.forgot" data-cy="forgetYourPasswordSelector"
          >Sie haben Ihr Passwort vergessen?</a
        >
      </div>

      <div class="alert alert-warning">
        <span jhiTranslate="global.messages.info.register.noaccount">Sie haben noch keinen Zugang?</span>
        <a class="alert-link" routerLink="/account/register" jhiTranslate="global.messages.info.register.link">Registrieren Sie sich</a>
      </div>
    </div>
  </div>
</div>
